module.exports = __webpack_public_path__ + "static/media/79780028-WyT0wSgs.085e0b9e.JPG";